import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../context/AppContext";

import "../../assets/css/crmphonebook/Agent.scss";
import "../../assets/css/crmphonebook/crmnew.css";

import { Link, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { simpleGetCallWithToken } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import Loader from "../Loader";

export default function UserDetailsForm() {
  const { sidebar, setSidebar, Dark, setDark, userData } =
    useContext(AppContext);
  const {} = useContext(AppContext);

  const { id } = useParams();
  const navigate = useNavigate();
  const [detailsdata, setDetailsData] = useState({});
  const [loading, setLoding] = useState(false);

  console.log("userDatails Id>>>", id);

  const navigetEditeAgentDedails = (id) => {
    navigate(`/UpdateUserDetails/${id}`);
  };

  const navigetCallHistoryDedails = (id) => {
    navigate(`/CallHistory/${id}`);
  };

  // const agentdetails = [
  //   {
  //     FirstName: "None",
  //     LastName: "None",
  //     Email: "pankaj.p@coudxperte.com",
  //     ContactNumber: "+919307776804",
  //     Gender: "NA",
  //     Type: "Agent",
  //     City: "NA",
  //     State: "NA",
  //     ExpectedCTC: " NA",
  //     ExpectedJobRole: " NA",
  //     Offer: "NA",
  //     PreferredLocation: "NA",
  //     AgreeForRelocation: "NA",
  //     Negotiable: "NA",
  //     JobRoleDescription: "",
  //     CurrentCompany: "NA",
  //     Projects: "",
  //     JobChangeReason: "",
  //     ResumeTitle: "",
  //     Communication: "NA",
  //     Remark: "NA",
  //     AdditionalNotes: "NA",
  //     ECTCNegotiable: "NA",
  //     ECTCMarketStandard: "NA",
  //     ECTCHike: "NA",
  //     RelevantExp: "NA",
  //     Lastorganization: "NA",
  //     ScheduleDay: "NA",
  //     ScheduleTime: "NA",
  //   },
  // ];

  const getAgentdetails = () => {
    setLoding(true);
    const url = id;
    simpleGetCallWithToken(ApiConfig.GET_USER_DETAILS + `${url}/`)
      .then((response) => {
        console.log("useDetails Data>>>>", response);
        setDetailsData(response?.user_details);
        setLoding(false);
      })
      .catch((err) => {
        console.log("adent Details Error>>>", err);
        setLoding(false);
      });
  };

  useEffect(() => {
    getAgentdetails();
  }, []);

  return (
    <>
      <div
        className={sidebar ? "taskMain " : "cx-active taskMain"}
        id="cx-main"
      >
        <div className="main-chat">
          <div className="sub-header-role mb-4">
            <h6 className="mt-2">User Details</h6>
          </div>
          <div id="tabsBelow" className="mt-4">
            <div className="button-maindiv">
              <div className="button-subdiv">
                <button
                  className="sml-btn-sub-header"
                  onClick={() => navigetEditeAgentDedails(detailsdata?.id)}
                >
                  <Link
                    // to="/UpdateUserDetails"
                    className="details-link"
                  >
                    Edit User Details
                  </Link>
                </button>

                <button
                  className="sml-btn-sub-header"
                  onClick={() => navigetCallHistoryDedails(detailsdata?.id)}
                >
                  <Link
                    // to="/CallHistory"
                    className="details-link"
                  >
                    Call History
                  </Link>
                </button>
              </div>
            </div>
            <div className="tabledata1">
              {/* {agentdetails.map((item) => ( */}
              {loading ? (
                <>
                  <Loader />
                </>
              ) : (
                <div className="tabledata UserDetails02">
                  <div className="col-md-12 UserDetails01">
                    <label
                      className="enter-role-text 
                    
                    "
                    >
                      First Name :
                    </label>
                    <label className="enter-role-text ">
                      {detailsdata.firstname}
                    </label>
                  </div>
                  <div className="col-md-12 UserDetails01">
                    <label
                      className="enter-role-text 
                    
                    "
                    >
                      Last Name :
                    </label>
                    <label className="enter-role-text ">
                      {detailsdata.lastname}
                    </label>
                  </div>
                  <div className="col-md-12 UserDetails01">
                    <label
                      className="enter-role-text 
                    
                    "
                    >
                      Email :
                    </label>
                    <label className="enter-role-text ">
                      {detailsdata.email}
                    </label>
                  </div>
                  <div className="col-md-12 UserDetails01">
                    <label
                      className="enter-role-text 
                    
                    "
                    >
                      Contact Number :
                    </label>
                    <label className="enter-role-text ">
                      {detailsdata.phone_number}
                    </label>
                  </div>
                  <div className="col-md-12 UserDetails01">
                    <label
                      className="enter-role-text 
                    
                    "
                    >
                      Gender :
                    </label>
                    <label className="enter-role-text ">
                      {detailsdata.gender}
                    </label>
                  </div>
                  <div className="col-md-12 UserDetails01">
                    <label
                      className="enter-role-text 
                    
                    "
                    >
                      Type :
                    </label>
                    <label className="enter-role-text ">
                      {detailsdata.type}
                    </label>
                  </div>
                  <div className="col-md-12 UserDetails01">
                    <label
                      className="enter-role-text 
                    
                    "
                    >
                      City :
                    </label>
                    <label className="enter-role-text ">
                      {detailsdata.City}
                    </label>
                  </div>
                  <div className="col-md-12 UserDetails01">
                    <label
                      className="enter-role-text 
                    
                    "
                    >
                      State :
                    </label>
                    <label className="enter-role-text ">
                      {detailsdata.state}
                    </label>
                  </div>
                  <div className="col-md-12 UserDetails01">
                    <label
                      className="enter-role-text 
                    
                    "
                    >
                      Expected CTC :
                    </label>
                    <label className="enter-role-text ">
                      {detailsdata.expected_ctc}
                    </label>
                  </div>
                  <div className="col-md-12 UserDetails01">
                    <label
                      className="enter-role-text 
                    
                    "
                    >
                      Expected Job Role :
                    </label>
                    <label className="enter-role-text ">
                      {detailsdata.expected_job_role}
                    </label>
                  </div>
                  <div className="col-md-12 UserDetails01">
                    <label
                      className="enter-role-text 
                    
                    "
                    >
                      Offer :
                    </label>
                    <label className="enter-role-text ">
                      {detailsdata.offer}
                    </label>
                  </div>
                  <div className="col-md-12 UserDetails01">
                    <label
                      className="enter-role-text 
                    
                    "
                    >
                      Preferred Location :
                    </label>
                    <label className="enter-role-text ">
                      {detailsdata.location}
                    </label>
                  </div>
                  <div className="col-md-12 UserDetails01">
                    <label
                      className="enter-role-text 
                    
                    "
                    >
                      Agree For Relocation :
                    </label>
                    <label className="enter-role-text ">
                      {detailsdata.agree_for_relocation}
                    </label>
                  </div>
                  <div className="col-md-12 UserDetails01">
                    <label
                      className="enter-role-text 
                    
                    "
                    >
                      Negotiable :
                    </label>
                    <label className="enter-role-text ">
                      {detailsdata.negotiable}
                    </label>
                  </div>
                  <div className="col-md-12 UserDetails01">
                    <label
                      className="enter-role-text 
                    
                    "
                    >
                      Job Role Description :
                    </label>
                    <label className="enter-role-text ">
                      {detailsdata.job_role_description}
                    </label>
                  </div>
                  <div className="col-md-12 UserDetails01">
                    <label
                      className="enter-role-text 
                    
                    "
                    >
                      Resume Title :
                    </label>
                    <label className="enter-role-text ">
                      {detailsdata.resume_title}
                    </label>
                  </div>
                  <div className="col-md-12 UserDetails01">
                    <label
                      className="enter-role-text 
                    
                    "
                    >
                      Communication :
                    </label>
                    <label className="enter-role-text ">
                      {detailsdata.communication}
                    </label>
                  </div>
                  <div className="col-md-12 UserDetails01">
                    <label
                      className="enter-role-text 
                    
                    "
                    >
                      Remark :
                    </label>
                    <label className="enter-role-text ">
                      {detailsdata.Remark}
                    </label>
                  </div>
                  <div className="col-md-12 UserDetails01">
                    <label
                      className="enter-role-text 
                    
                    "
                    >
                      Additional Notes :
                    </label>
                    <label className="enter-role-text ">
                      {detailsdata.Additional_notes}
                    </label>
                  </div>
                  <div className="col-md-12 UserDetails01">
                    <label
                      className="enter-role-text 
                    
                    "
                    >
                      ECTC Market Standard :
                    </label>
                    <label className="enter-role-text ">
                      {detailsdata.ectc_market_standard}
                    </label>
                  </div>
                  <div className="col-md-12 UserDetails01">
                    <label
                      className="enter-role-text 
                    
                    "
                    >
                      ECTCHike :
                    </label>
                    <label className="enter-role-text ">
                      {detailsdata.ectc_hike}
                    </label>
                  </div>
                  <div className="col-md-12 UserDetails01">
                    <label
                      className="enter-role-text 
                    
                    "
                    >
                      Relevant Exp:
                    </label>
                    <label className="enter-role-text ">
                      {detailsdata.relevant_exp}
                    </label>
                  </div>
                  <div className="col-md-12 UserDetails01">
                    <label
                      className="enter-role-text 
                    
                    "
                    >
                      Last day in organization:
                    </label>
                    <label className="enter-role-text ">
                      {detailsdata.last_day_in_organization}
                    </label>
                  </div>
                  <div className="col-md-12 UserDetails01">
                    <label
                      className="enter-role-text 
                    
                    "
                    >
                      Schedule Meeting Day:
                    </label>
                    <label className="enter-role-text ">
                      {detailsdata.schedule_meeting_day}
                    </label>
                  </div>
                  <div className="col-md-12 UserDetails01">
                    <label
                      className="enter-role-text 
                    
                    "
                    >
                      Schedule Meeting Time:
                    </label>
                    <label className="enter-role-text ">
                      {detailsdata.schedule_meting_time}
                    </label>
                  </div>
                </div>
              )}
              {/* ))} */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
